<template>
  <div v-if="category" class="shop-subcategories">
    <AlertComponent v-if="category.status === 'expired'" theme="error"
      >{{ $t('contractExpiredMessage') }},
      <a
        href="#"
        @click.prevent="
          bus.$emit('inquiry', {
            scoped: true,
            title: `${$t('contractExpiredMessage')}: ${category.label}`,
          })
        "
        >{{ $t('contactSeller').toLowerCase() }}</a
      ></AlertComponent
    >

    <AlertComponent v-if="['signed', 'accepted'].includes(category.status)" theme="success">
      <template v-if="category.status === 'accepted'">{{
        $t('shopCategoryAcceptedMessage')
      }}</template>
      <template v-if="category.status === 'signed'">{{ $t('shopCategorySignedMessage') }}</template>
    </AlertComponent>

    <ReadMore
      v-if="category.description"
      :key="category.id"
      :value="category.description"
      :limit="3"
      class="shop-subcategories__description"
    />

    <Subcategory
      v-for="(subcategory, index) in subcategories"
      :key="index"
      :value="subcategory"
      :category="category"
      :readonly="['signed', 'accepted', 'expired'].includes(category.status)"
      :active="value === subcategory"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import { ConditionFilter } from '../utils'
import Subcategory from './Subcategory.vue'
import { AlertComponent } from 'vue-elder-alert'
import ReadMore from '../components/ReadMore.vue'

const images = []
function preload(items) {
  items.forEach(item => {
    const img = new Image()
    img.src = item

    images.push(img)
  })
}

export default {
  inject: ['shop', 'bus'],
  props: {
    value: Object,
    category: Object,
  },
  watch: {
    category: {
      handler() {
        const images = [
          ...this.category.categories
            .flatMap(({ items }) => items)
            .flatMap(({ product }) => product.images.map(({ url }) => url)),
          ...this.shop.contextualImages.flatMap(({ images }) => images.map(({ url }) => url)),
        ]

        if (!images.length) return
        preload(images)
      },
      immediate: true,
    },
  },
  computed: {
    subcategories() {
      if (!this.category) return []
      return this.category.categories.filter(category => ConditionFilter(category, this.shop))
    },
  },
  components: {
    ReadMore,
    Subcategory,
    AlertComponent,
  },
}
</script>

<style lang="scss">
.shop-subcategories {
  display: flex;
  flex-direction: column;

  gap: 1.5rem;

  &__description {
    h2 {
      margin-block-end: 0.2em;
    }

    p:first-of-type {
      margin-block-start: 0;
    }

    p:last-child {
      margin-block-end: 0;
    }
  }
}
</style>
